var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickIconDp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1208 0.849506C13.287 0.749538 13.4855 0.717832 13.6745 0.761042C13.8636 0.804253 14.0286 0.91902 14.1348 1.08126L14.8773 2.21376C14.9741 2.3617 15.0155 2.53909 14.9943 2.7146C14.973 2.89011 14.8904 3.05246 14.7611 3.17301L14.7588 3.17601L14.7483 3.18576L14.7056 3.22551L14.5368 3.38676C13.6031 4.2925 12.6977 5.22695 11.8218 6.18876C10.1741 8.00076 8.21732 10.3723 6.90032 12.6733C6.53282 13.3153 5.63507 13.4533 5.10257 12.899L0.238819 7.84551C0.169118 7.77306 0.114693 7.68734 0.0787809 7.59344C0.0428686 7.49954 0.0262012 7.39937 0.0297695 7.2989C0.0333377 7.19843 0.0570687 7.09971 0.0995519 7.00859C0.142035 6.91747 0.202404 6.83583 0.277069 6.76851L1.74707 5.44251C1.87625 5.32604 2.04189 5.25809 2.21565 5.25029C2.38941 5.24249 2.56047 5.29533 2.69957 5.39976L5.18132 7.26051C9.05807 3.43776 11.2563 1.97076 13.1208 0.849506Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIconDp);
export default __webpack_public_path__ + "static/media/tick-icon-dp.0a7bf91da73d855100e4f29f3a96ae11.svg";
export { ForwardRef as ReactComponent };